import React from 'react';
import { IconSvgProps } from '@models/common';

const AIInputLogo: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.50008 20.3334L9.05114 18.3404C8.67034 16.65 7.35021 15.3298 5.65973 14.949L3.66675 14.5001L5.65973 14.0511C7.35021 13.6703 8.67034 12.3502 9.05114 10.6597L9.50008 8.66675L9.94902 10.6597C10.3298 12.3502 11.65 13.6703 13.3404 14.0511L15.3334 14.5001L13.3404 14.949C11.65 15.3298 10.3298 16.65 9.94902 18.3404L9.50008 20.3334Z'
        stroke='url(#paint0_linear_10035_96658)'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <path
        d='M16.1667 12.0001L15.8461 10.5765C15.5741 9.36904 14.6311 8.42609 13.4236 8.15409L12.0001 7.83342L13.4236 7.51274C14.6311 7.24074 15.5741 6.29779 15.8461 5.09031L16.1667 3.66675L16.4874 5.09031C16.7594 6.29779 17.7024 7.24074 18.9099 7.51274L20.3334 7.83341L18.9099 8.15409C17.7024 8.42609 16.7594 9.36904 16.4874 10.5765L16.1667 12.0001Z'
        stroke='url(#paint1_linear_10035_96658)'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_10035_96658'
          x1='3.66675'
          y1='11.8367'
          x2='20.3334'
          y2='11.8367'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#4730EE' />
          <stop
            offset='0.348958'
            stopColor='#724FFB'
          />
          <stop
            offset='0.692708'
            stopColor='#B879C4'
          />
          <stop
            offset='1'
            stopColor='#EF8278'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_10035_96658'
          x1='3.66675'
          y1='11.8367'
          x2='20.3334'
          y2='11.8367'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#4730EE' />
          <stop
            offset='0.348958'
            stopColor='#724FFB'
          />
          <stop
            offset='0.692708'
            stopColor='#B879C4'
          />
          <stop
            offset='1'
            stopColor='#EF8278'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AIInputLogo;
